<template>
    <psi-form-layout-section
        title="Billing Contact"
        :icon="$config('icons.billing')"
        btn-label="Save Contact"
        :btn-icon="$config('icons.billing')"
        :btn-disabled="$_.get(program, 'id', 0) === 0"
        @section-save="save"
        :loading="sectionLoading.billing"
    >
        <psi-form-section
            :ref="section.ref"
            :value="modelData"
            :name="section.name"
            label=""
            :fields="fields"
            color="secondary"
        ></psi-form-section>
    </psi-form-layout-section>
</template>
<script>
export default {
    name: "program-billing-contact",
    components: {},
    props: {
        id: {
            type: String,
            required: true,
        },
        program: {
            type: Object,
            required: true,
        },
        sectionLoading: {
            type: Object,
            required: false,
            default: () => {
                return {
                    billing: false,
                };
            },
        },
    },
    data() {
        return {
            section: {
                name: "input-program-billing-contact",
                ref: "billing-contact",
            },
            modelData: {},
        };
    },
    computed: {
        fields() {
            return [
                {
                    type: "text",
                    name: "name",
                    key: "name",
                    label: "Name",
                    icon: this.$config("icons.name"),
                    required: true,
                },
                {
                    type: "text",
                    name: "email",
                    key: "email",
                    label: "Email",
                    format: "email",
                    icon: this.$config("icons.email"),
                    required: false,
                },
                {
                    type: "text",
                    name: "phone",
                    key: "phone",
                    label: "Phone",
                    format: "tel",
                    required: true,
                    icon: this.$config("icons.phone"),
                },
            ];
        },
    },
    watch: {
        program: {
            immediate: true,
            handler(program) {
                if (Object.keys(program).length > 0) {
                    // initial contact value may be an empty array, we want an object
                    this.modelData = Array.isArray(program.contact)
                        ? this.initialize()
                        : program.contact;
                }
            },
        },
    },
    methods: {
        save() {
            if (this.$refs[this.section.ref].validate()) {
                const payload = {
                    id: this.program.id,
                    contact: this.modelData,
                };
                this.$emit("update", this.id, payload);
            }
        },
        initialize() {
            return this.fields.reduce((acc, curr) => {
                acc[curr.key] = "";
                return acc;
            }, {});
        },
    },
    mounted() {},
};
</script>

<style scoped>
</style>